var React = require('react');

function Grid2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.200195 8.59995H8.60019V0.199951H0.200195V8.59995ZM12.8002 33.7999H21.2002V25.4H12.8002V33.7999ZM0.200195 33.7999H8.60019V25.4H0.200195V33.7999ZM0.200195 21.2H8.60019V12.8H0.200195V21.2ZM12.8002 21.2H21.2002V12.8H12.8002V21.2ZM25.4002 0.199951V8.59995H33.8002V0.199951H25.4002ZM12.8002 8.59995H21.2002V0.199951H12.8002V8.59995ZM25.4002 21.2H33.8002V12.8H25.4002V21.2ZM25.4002 33.7999H33.8002V25.4H25.4002V33.7999Z","fill":"#6975BD"}));
}

Grid2.defaultProps = {"viewBox":"0 0 34 34","fill":"none"};

module.exports = Grid2;

Grid2.default = Grid2;
